const requestExtraction = async (url, options = {}) => {
    const response = await fetch(url, {
        credentials: "same-origin",
        cache: "no-store",
        ...options,
        headers: { Accept: "application/json", ...options.headers },
    });
    if (!response.ok) {
        const error = new Error("equip.extraction.extractionError");
        error.status = response.status;
        error.body = { error: "equip.extraction.extractionError" };
        throw error;
    }
    return response.json();
};

export const getMediaExtraction = (url) =>
    requestExtraction(url, { method: "GET" });

export const startMediaExtraction = async (url, { force = false } = {}) => {
    const target = new URL(url, window.location.href);
    target.searchParams.set("force", force ? "1" : "0");
    return requestExtraction(target.toString(), {
        method: "POST",
    });
};
